import React from 'react'
import Page from '../components/Page'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { Button, Card, CardBody, CardHeader, Col, Label, Row, Nav, NavItem, NavLink, TabContent, TabPane, Form, Input, Modal, ModalBody, ModalFooter, ModalHeader, ButtonGroup, FormGroup, Spinner, Table } from 'reactstrap'
import { MdEdit, MdDone, MdClear, MdDelete, MdSettings, MdShoppingCart, MdWarning } from 'react-icons/md'
import { FaEdit } from 'react-icons/fa'
import { Redirect } from 'react-router'
import StorageService from '../services/StorageService'
import axios from 'axios'
import PosStoreForm from '../components/PosStoreForm'
import PosTaxTable from '../components/PosTaxTable'
import PosPaymentTypeTable from '../components/PosPaymentTypeTable'
import PosUserTable from '../components/PosUserTable'
import PosStoreProductTable from '../components/PosStoreProductTable'
import PosScheduleTable from '../components/PosScheduleTable'
import PosSyncStockTable from '../components/PosSyncStockTable'
import classnames from 'classnames'
import PosStoreConfigureModal from '../components/PosStoreConfigureModal'
import PosShippingTable from '../components/PosShippingTable'
import PosDeliveryCollectionTable from '../components/PosDeliveryCollectionTable'
import PosPromoTable from '../components/PosPromoTable'
import PosEmailAlertTable from '../components/PosEmailAlertTable'
import PosSMSAlertTable from '../components/PosSMSAlertTable'

import moment from 'moment-timezone'

import { IconWidget, NumberWidget, TextWidget } from '../components/Widget'
import { IconContext } from 'react-icons'

const tab_admin = [{ name: 'Product' }, { name: 'User' }, { name: 'Payment Type' }, { name: 'Tax' }, { name: 'Schedule' }, { name: 'Sync Stock' }, { name: 'Shipping' }, { name: 'Delivery Collection' }, { name: 'Promo' }, { name: 'Email Alert' }, { name: 'SMS Alert' }]

const tab = [{ name: 'Product' }, { name: 'Schedule' }]

class PosStoreDetailPage extends React.Component {
  _isMounted = true
  comp = StorageService.getSession('selected_org')
  access = StorageService.getSession('user_access')

  constructor(props) {
    //let storeRole = this.access.store.find(x => x.store_id == storeid).role;
    super(props)
    this.state = {
      role: this.access.store.find(x => x.store_id == this.props.match.params.id).role,
      storeRole: this.access.store.find(x => x.store_id == this.props.match.params.id).role,
      isLoading: false,
      modal: false,
      uploadModal: false,
      mobilebannerModal: false,
      configureModal: false,
      ecartModal: false,
      siloModal: false,
      redirect: false,
      tabList: this.access.store.find(x => x.store_id == this.props.match.params.id).role == 'Admin' ? tab_admin : tab,
      activeTab: '1',
      storeList: [],
      fullStoreList: [],
      store_id: '',
      store_code: '',
      store_name: '',
      store_location: '',
      remarks: '',
      company_id: '',
      company_name: '',
      timezone: '+8:00',
      admin_email: '',
      report_time: '',
      taxList: [],
      rounding: '',
      enable_ecart: '',
      enable_silo: '',
      pos: '',
      self_collection: '',
      delivery: '',
      service_order: '',
      image_url: '',
      web_banner: '',
      web_header: '',
      web_footer: '',
      invoice_info: '',
      footer_info: '',
      quotation_tc: '',
      invoice_tc: '',
      modeArray: [],
      ecartUrl: '',
      order_mode: '',
      open_date: '',
      close_date: '',
      show_timer: '',
      timer_title: '',
      opentime: '',
      closetime: '',
      postal_location: '',
      postal_latlong: '',
      edit_order_mode: '',
      edit_opendate: '',
      edit_closedate: '',
      edit_opentime: '',
      edit_closetime: '',
      edit_show_timer: '',
      edit_timer_title: '',
      edit_postal_location: '',
      edit_postal_latlong: '',
      store_type: '',
      edit_banner: '',
      edit_show_watsapp: '',
      edit_watsapp: '',
      edit_show_price_filter: '',
      show_watsapp: '',
      watsapp: '',
      show_price_filter: '',
      marketplace: 0,
      startdate: '',
      disable: '',
      billing_type: '',
      next_bill: '',
      billing_amt: '',
      payment_status: '',
      plan: '',
      store_limit: '',
      ecart_limit: '',
      product_limit: '',
      customer_limit: '',
      sms_credit: '',
      sms_count: '',
      store_count: '',
      ecart_count: '',
      product_count: '',
      customer_count: '',
      edit_mobile_banner: '',
      password_ecart: '',
      password: '',
      edit_password_ecart: '',
      edit_password: '',
      silo_hide_price: '',
      edit_silo_hide_price: '',
      silo_filter_tag: '',
      edit_silo_filter_tag: '',
      self_collection_disable_billing: '',
      edit_self_collection_disable_billing: '',
      auto_cancel: 0,
      running_invoice:0,
      runninginvoiceModal:false,
      edit_running_invoice: 0
    }
  }

  componentDidMount() {
    this.getStoreList()
    //this.getLicense();
    this.getStoreDetail()
    this.getTax()
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  getStoreList = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const access = StorageService.getSession('user_access')

    // console.log(access);
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    }

    axios
      .post(url + ':3001/v1/store', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          let storeList = []

          for (let i of access.store) {
            for (let j of result.data) {
              if (j.store_id === i.store_id) {
                if (i.role == 'Admin' || i.role == 'Supervisor' || i.role == 'Financial' || i.role == 'Manager' || i.role == 'Superuser') {
                  storeList.push(j)
                }
              }
            }
          }
          this.setState({
            storeList: storeList,
            filterList: storeList,
            fullStoreList: result.data,
            isLoading: false,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  getTax() {
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    }
    axios
      .post(`${url}:3001/v1/tax`, data)
      .then(res => {
        this.setState({ taxList: res.data.data })
      })
      .catch(error => {
        console.log(error)
      })
  }

  toggle = () => () => {
    return this.setState({
      modal: !this.state.modal,
      isEdit: true,
      selectedStoreId: this.state.store_id,
    })
  }

  toggleEcart = () => () => {
    return this.setState({
      ecartModal: !this.state.ecartModal,
      edit_order_mode: this.state.order_mode,
      edit_opendate: this.state.open_date,
      edit_closedate: this.state.close_date,
      edit_opentime: this.state.opentime,
      edit_closetime: this.state.closetime,
      edit_show_timer: this.state.show_timer,
      edit_timer_title: this.state.timer_title,
      edit_postal_location: this.state.postal_location,
      edit_postal_latlong: this.state.postal_latlong,
      edit_show_watsapp: this.state.show_watsapp,
      edit_watsapp: this.state.watsapp,
      edit_show_price_filter: this.state.show_price_filter,
      edit_password_ecart: this.state.password_ecart,
      edit_password: this.state.password,
    })
  }

  toggleSilo = () => () => {
    return this.setState({
      siloModal: !this.state.siloModal,
      edit_silo_hide_price: this.state.silo_hide_price,
      edit_silo_filter_tag: this.state.silo_filter_tag,
      edit_self_collection_disable_billing: this.state.self_collection_disable_billing,
    })
  }

  toggleUpload = () => () => {
    return this.setState({
      uploadModal: !this.state.uploadModal,
    })
  }

  toggleMobileBanner = () => () => {
    return this.setState({
      mobilebannerModal: !this.state.mobilebannerModal,
    })
  }

  toggleConfigure = () => () => {
    return this.setState({
      configureModal: !this.state.configureModal,
    })
  }

  toggleConfirmModal = () => () => {
    return this.setState({
      confirmModal: !this.state.confirmModal,
    })
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      })
    }
  }

  toggleRunningInvoice = () => () => {
    return this.setState({
      runninginvoiceModal : !this.state.runninginvoiceModal,
      edit_running_invoice : this.state.running_invoice
    });
  }

  closeModal = (title, message, level, reload) => {
    this.notificationSystem.addNotification({
      title: title,
      message: message,
      level: level,
      position: 'br',
      autoDismiss: 2,
      dismissible: 'click',
    })

    this.setState({
      modal: false,
      configureModal: false,
      uploadModal: false,
    })

    if (reload) {
      window.location.reload()
    } else {
      this.getStoreDetail()
    }
  }

  changeHandler = e => {
    let { name, value } = e.target
    this.setState({
      [name]: value,
    })
  }

  checkHandler = e => {
    const { name, value } = e.target
    this.setState({
      [name]: !this.state[name],
    })
  }

  mobileHandler = e => {
    const re = /^[0-9\b]+$/
    let { name, value } = e.target
    // if value is not blank, then test the regex

    if (e.target.value === '' || re.test(e.target.value)) {
      this.setState({ [name]: value })
    }
  }

  postalHandler = e => {
    let { name, value } = e.target
    this.setState({
      [name]: value,
    })

    if (value.length === 6) {
      this.setState({
        isLoading: true,
      })
      this.SearchLocation(value)
    }
  }

  SearchLocation(poscode) {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_API_URL
    const data = {
      session_key: user.session_key,
      postal_code: poscode,
    }
    axios
      .post(url + ':3001/v1/onemap/searchAddress', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.notificationSystem.addNotification({
            title: <MdClear />,
            message: result.message,
            level: 'error',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          })

          return
        }

        if (this._isMounted) {
          if (result.data.length) {
            let latitude = result.data[0].LATITUDE
            let longitude = result.data[0].LONGITUDE

            let latlong = `${latitude}, ${longitude}`

            this.setState({
              edit_postal_latlong: latlong,
            })
          } else {
            this.notificationSystem.addNotification({
              title: <MdClear />,
              message: 'Location Not Found',
              level: 'error',
              position: 'br',
              autoDismiss: 4,
              dismissible: 'click',
            })
          }
        }

        this.setState({
          isLoading: false,
        })
      })
      .catch(error => {
        alert(error)
        this.setState({ isLoading: false })
      })
  }

  EcartConfigure = e => {
    e.preventDefault()
    const user = StorageService.getSession('user_info')
    const url = process.env.REACT_APP_UNITY_API2_URL

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.store_id,
      ecart_ordermode: this.state.edit_order_mode,
      ecart_opendate: this.state.edit_opendate,
      ecart_closedate: this.state.edit_closedate,
      ecart_opentime: this.state.edit_opentime,
      ecart_closetime: this.state.edit_closetime,
      show_timer: this.state.edit_show_timer ? 1 : 0,
      timer_title: this.state.edit_timer_title,
      postal_location: this.state.edit_postal_location,
      postal_latlong: this.state.edit_postal_latlong,
      show_watsapp: this.state.edit_show_watsapp ? 1 : 0,
      // watsapp: this.state.edit_show_watsapp == 1 ? this.state.edit_watsapp : '',
      watsapp: this.state.edit_watsapp,
      show_price_filter: this.state.edit_show_price_filter,
      password_ecart: this.state.edit_password_ecart ? '1' : '0',
      password: this.state.edit_password,
      update_by: user.email,
    }

    axios
      .post(url + ':3001/v6/store/update/ecartconfig', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.notificationSystem.addNotification({
            title: <MdClear />,
            message: result.message,
            level: 'error',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          })
          return
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Store updated successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
        this.setState({ ecartModal: false })
        this.getStoreDetail()
      })
      .catch(error => {
        alert(error)
      })
  }

  SiloConfigure = e => {
    e.preventDefault()
    const user = StorageService.getSession('user_info')
    const url = process.env.REACT_APP_UNITY_API2_URL

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.store_id,
      silo_hide_price: this.state.edit_silo_hide_price,
      silo_filter_tag: this.state.edit_silo_filter_tag ? 1 : 0,
      self_collection_disable_billing: this.state.edit_self_collection_disable_billing ? 1 : 0,
      update_by: user.email,
    }

    axios
      .post(url + ':3001/v2/store/update/siloconfig', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.notificationSystem.addNotification({
            title: <MdClear />,
            message: result.message,
            level: 'error',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          })
          return
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Store updated successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
        this.setState({ siloModal: false })
        this.getStoreDetail()
      })
      .catch(error => {
        alert(error)
      })
  }

  Banner = e => {
    e.preventDefault()
    const user = StorageService.getSession('user_info')
    const url = process.env.REACT_APP_UNITY_API2_URL

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.store_id,
      b64image: this.state.edit_banner,
      created_by: user.email,
    }

    axios
      .post(url + ':3001/v1/store/banner', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.notificationSystem.addNotification({
            title: <MdClear />,
            message: result.message,
            level: 'error',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          })
          return
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Banner updated successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
        this.setState({ uploadModal: false })
        this.getStoreDetail()
      })
      .catch(error => {
        alert(error)
      })
  }

  MobileBanner = e => {
    e.preventDefault()
    const user = StorageService.getSession('user_info')
    const url = process.env.REACT_APP_UNITY_API2_URL

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.store_id,
      b64image: this.state.edit_mobile_banner,
      created_by: user.email,
    }

    axios
      .post(url + ':3001/v1/store/banner/mobile', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.notificationSystem.addNotification({
            title: <MdClear />,
            message: result.message,
            level: 'error',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          })
          return
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Mobile Banner updated successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
        this.setState({ mobilebannerModal: false })
        this.getStoreDetail()
      })
      .catch(error => {
        alert(error)
      })
  }

  lastInvoiceHandler = e => {
    const {name, value} = e.target
    
    this.setState({
      [name]:value
    })

  }

  last_invoice = e =>{
    e.preventDefault();
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data ={
      session_key:'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id:this.state.store_id,
      invoice_no:this.state.edit_running_invoice,
      update_by:user.email
    }

    axios.post(url + ':3001/v1/store/update/invoice', data)
    .then(response => {
      const result = response.data;
      if(result.error == true){
        this.notificationSystem.addNotification({
          title: <MdClear />,
          message: result.message,
          level: 'error',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        });
        return;
      }

      this.notificationSystem.addNotification({
        title: <MdDone />,
        message: 'Last Invoice updated successfully.',
        level: 'success',
        position: 'br',
        autoDismiss: 4,
        dismissible: 'click',
      })

      this.setState({runninginvoiceModal : false});
      this.getStoreDetail();
    }).catch(error => {
      alert(error);
    })
  }

  getStoreDetail = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      store_id: this.props.match.params.id,
    }

    axios
      .post(url + ':3001/v1/store/detail', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }

        let modeArray = []
        if (result.data.pos) {
          modeArray.push('POS')
        }
        if (result.data.self_collection) {
          modeArray.push('Self Collection')
        }
        if (result.data.delivery) {
          modeArray.push('Delivery')
        }
        if (result.data.service_order) {
          modeArray.push('Service Order')
        }
        let ecartUrl = `https://store.unitysuite.app/${this.comp.CompanyCode}/${result.data.store_code}`
        let siloUrl = `https://silo.unitysuite.app/${this.comp.CompanyCode}/${result.data.store_code}`
        this.setState({
          store_id: this.props.match.params.id,
          store_code: result.data.store_code,
          store_name: result.data.name,
          company_name: result.data.company_name,
          store_location: result.data.location,
          remarks: result.data.remarks,
          timezone: result.data.timezone,
          admin_email: result.data.admin_email,
          report_time: result.data.report_time,
          rounding: result.data.rounding,
          pos: result.data.pos,
          self_collection: result.data.self_collection,
          delivery: result.data.delivery,
          service_order: result.data.service_order,
          image_url: result.data.image_url == null ? '' : result.data.image_url,
          web_header: result.data.web_header,
          web_banner: result.data.web_banner,
          web_footer: result.data.web_footer,
          invoice_info: result.data.invoice_info,
          footer_info: result.data.footer_info,
          quotation_tc: result.data.quotation_tc,
          invoice_tc: result.data.invoice_tc,
          modeArray: modeArray,
          enable_ecart: result.data.enable_ecart,
          enable_silo: result.data.enable_silo,
          ecartUrl: ecartUrl,
          siloUrl: siloUrl,
          order_mode: result.data.ecart_ordermode,
          open_date: result.data.ecart_opendate,
          close_date: result.data.ecart_closedate,
          opentime: result.data.ecart_opentime,
          closetime: result.data.ecart_closetime,
          postal_location: result.data.postal_location,
          postal_latlong: result.data.postal_latlong,
          store_type: result.data.store_type,
          show_timer: result.data.show_timer,
          timer_title: result.data.timer_title,
          show_watsapp: result.data.show_watsapp,
          watsapp: result.data.watsapp,
          show_price_filter: result.data.show_price_filter,
          marketplace: result.data.marketplace,
          password_ecart: result.data.password_ecart,
          password: result.data.password,
          silo_hide_price: result.data.silo_hide_price,
          silo_filter_tag: result.data.silo_filter_tag,
          self_collection_disable_billing: result.data.self_collection_disable_billing,
          auto_cancel: result.data.auto_cancel,
          running_invoice: result.data.running_invoice
        })
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == 401) {
            alert(error.response.message)
            //this.setState({ redirect: true });
          }
          alert(error.response.message)
        } else {
          alert(error)
        }
      })
  }

  delete = () => {
    const user = StorageService.getSession('user_info')
    const url = process.env.REACT_APP_UNITY_API2_URL

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.store_id,
      delete_by: user.email,
    }

    axios
      .post(url + ':3001/v1/store/delete', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.notificationSystem.addNotification({
            title: <MdClear />,
            message: result.message,
            level: 'error',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          })
          return
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Store deleted successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
        this.setState({ confirmModal: false })
        setTimeout(() => {
          this.props.history.push('/posstore')
        }, 1000)
      })
      .catch(error => {
        alert(error)
      })
  }

  handleAttachmentChange = async event => {
    let { name } = event.target
    let reader = new FileReader()
    if (Object.keys(event.target.files).length == 0) {
      // Object is empty
    } else {
      let file = event.target.files[0]
      console.log(file)
      if (file.size > 2000000) {
        // alert('Banner size limit to 2mb');
        this.notificationSystem.addNotification({
          title: <MdWarning />,
          message: 'Logo size limit to 2MB',
          level: 'error',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
        event.target.value = null
      } else {
        if (!file.name.toLowerCase().match(/\.(jpg|jpeg|png|gif)$/)) {
          this.notificationSystem.addNotification({
            title: <MdWarning />,
            message: 'Please select valid photo.',
            level: 'error',
            position: 'br',
            autoDismiss: 2,
            dismissible: 'click',
          })
        } else {
          reader.onloadend = () => {
            this.setState({
              [name]: reader.result ? reader.result.split(',')[1] : '',
            })
          }
          reader.readAsDataURL(file)
        }
      }
    }
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/" />
    }

    const { activeTab } = this.state

    return (
      <Page
        className="PosStoreDetailPage"
        title="Store Detail"
        breadcrumbs={[
          { name: 'Store', active: false, path: '/posstore' },
          { name: 'Detail', active: true, path: '/posstore:id' },
        ]}>
        <NotificationSystem dismissible={false} ref={notificationSystem => (this.notificationSystem = notificationSystem)} style={NOTIFICATION_SYSTEM_STYLE} />

        <Row>
          <Col xl={12} lg={12} md={12}>
            <Card className="ps-card-display">
              <CardHeader className="d-flex align-items-center justify-content-between ps-bg-gradient">
                Store Information
                <div className="ps-action-button">
                  <Button className="theme-button unity-theme-button-transparent" onClick={this.toggleEcart()}>
                    <MdShoppingCart />
                    ECart
                  </Button>
                  <Button className="theme-button unity-theme-button-transparent" onClick={this.toggleSilo()} disabled={this.state.enable_silo == 1 ? false : true}>
                    <MdShoppingCart />
                    Silo
                  </Button>
                  <Button className="theme-button unity-theme-button-transparent" onClick={this.toggleConfigure('EDIT', this.state.selectedStoreId)}>
                    <MdSettings />
                    Configuration
                  </Button>

                  {this.state.storeRole == 'Admin' && (
                    <>
                      <Button className="theme-button unity-theme-button-transparent" onClick={this.toggle('EDIT', this.state.selectedStoreId)}>
                        <MdEdit />
                        Edit
                      </Button>
                    </>
                  )}

                  {this.state.role == 'Admin' && (
                    <>
                      <Button className="theme-button unity-theme-button-transparent" onClick={this.toggleConfirmModal()}>
                        <MdDelete />
                        Delete
                      </Button>
                    </>
                  )}
                </div>
              </CardHeader>

              <CardBody>
                <Row form>
                  <Col
                    lg={12}
                    style={{
                      backgroundImage: `url(${this.state.web_banner})`,
                      marginBottom: '16px',
                    }}
                    className="ps-title-bar">
                    <ButtonGroup>
                      <Button className="ps-input-small" onClick={this.toggleUpload()}>
                        Upload
                      </Button>
                      {(this.comp.CompanyID == 'AJyi0vFqwrX2xnxV2lFl' || this.comp.CompanyID == 'IsKbNNvTITlL46EQuyJ7') && (
                        <Button className="ps-input-small" onClick={this.toggleMobileBanner()}>
                          Mobile Banner
                        </Button>
                      )}
                    </ButtonGroup>
                  </Col>

                  <Col lg={4}>
                    <Label>Store Code</Label>
                    <p>{this.state.store_code}</p>
                  </Col>
                  <Col lg={4}>
                    <Label>Name</Label>
                    <p>{this.state.store_name}</p>
                  </Col>
                  <Col lg={4}>
                    <Label>Location</Label>
                    <p>{this.state.store_location}</p>
                  </Col>

                  <Col lg={4}>
                    <Label>Timezone</Label>
                    <p>{this.state.timezone}</p>
                  </Col>
                  <Col lg={4}>
                    <Label>Admin</Label>
                    <p>{this.state.admin_email}</p>
                  </Col>
                  <Col lg={4}>
                    <Label>Report Time</Label>
                    <p>{this.state.report_time}</p>
                  </Col>
                  <Col lg={4}>
                    <Label>Rounding</Label>
                    <p>
                      <span className={'ps-indicator ' + (this.state.rounding == '1' ? 'on' : 'off')}>{this.state.rounding == '1' ? 'Yes' : 'No'}</span>
                    </p>
                  </Col>
                  {/* <Col lg={4}>
                    <Label>Ecart</Label>
                    {this.state.enable_ecart ? (
                      <>
                        <p>
                          <a href={this.state.ecartUrl} target="_blank">
                            <img src={`https://chart.googleapis.com/chart?cht=qr&chld=H|1&chs=100x100&chl=${this.state.ecartUrl}`} />
                          </a>
                        </p>
                        <Button
                          className="theme-button theme-button-primary"
                          onClick={() => {
                            this.props.history.push({
                              pathname: '/posstore/' + this.state.store_id + '/configureecart',
                            })
                          }}>
                          Configure Page
                        </Button>
                      </>
                    ) : (
                      <p>
                        <span className={'ps-indicator ' + 'off'}>Disabled</span>
                      </p>
                    )}
                  </Col> */}
                  <Col lg={4}>
                    <Label>Modes</Label>
                    <p>
                      {this.state.modeArray.map((i, index) => {
                        return (index > 0 ? ', ' : '') + i
                      })}
                    </p>
                  </Col>
                  <Col lg={4}>
                    <Label>Store Type</Label>
                    <p>{this.state.store_type}</p>
                  </Col>
                  <Col lg={4}>
                    <Label>Show Timer Countdown</Label>
                    <p>
                      <span className={'ps-indicator ' + (this.state.show_timer == '1' ? 'on' : 'off')}>{this.state.show_timer == '1' ? 'Yes' : 'No'}</span>
                    </p>
                  </Col>
                  <Col lg={4}>
                    <Label>Timer Title</Label>
                    <p>{this.state.timer_title}</p>
                  </Col>
                  <Col lg={4}>
                    <Label>Remarks</Label>
                    <p>{this.state.remarks}</p>
                  </Col>
                  <Col lg={4}>
                    <Label>Last Invoice</Label>
                    <p>{this.state.running_invoice}{' '}
                      <Button color='link' style={{padding : '2px 0px 5px 5px' }} onClick={this.toggleRunningInvoice()}>
                        <IconContext.Provider value={{color:'#2a2c6b'}}>
                          <FaEdit size={16}/>
                        </IconContext.Provider>
                      </Button>
                    </p>
                  </Col>
                  <Col lg={12}>
                    <p></p>
                  </Col>
                  <Col lg={12}>
                    <Label>Link</Label>
                    <Table responsive hover className="ps-table tb-col-5">
                      <tbody>
                        <tr>
                          <td>
                            <p>Ecart</p>
                          </td>
                          <td>
                            {this.state.enable_ecart == 1 && (
                              <p>
                                <a href={this.state.ecartUrl} target="_blank">
                                  {this.state.ecartUrl}
                                </a>
                              </p>
                            )}
                          </td>
                          <td>
                            {this.state.enable_ecart == 1 && (
                              <p>
                                <a href={this.state.ecartUrl} target="_blank">
                                  <img src={`https://image-charts.com/chart?cht=qr&chld=H|1&chs=100x100&chl=${this.state.ecartUrl}`} />
                                </a>
                              </p>
                            )}
                          </td>
                          <td>
                            <Button
                              className="theme-button theme-button-primary"
                              onClick={() => {
                                this.props.history.push({
                                  pathname: '/posstore/' + this.state.store_id + '/configureecart',
                                })
                              }}>
                              Configure Page
                            </Button>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p>Silo</p>
                          </td>
                          <td>
                            <p>
                              {this.state.enable_silo == 1 && (
                                <p>
                                  <a href={this.state.siloUrl} target="_blank">
                                    {this.state.siloUrl}
                                  </a>
                                </p>
                              )}
                            </p>
                          </td>
                          <td>
                             {this.state.enable_silo == 1 && (
                              <p>
                                <a href={this.state.siloUrl} target="_blank">
                                  <img src={`https://image-charts.com/chart?cht=qr&chld=H|1&chs=100x100&chl=https://silo.unitysuite.app/`} />
                                </a>
                              </p>
                            )}
                          </td>
                          <td></td>
                        </tr>
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col xl={12} lg={12} md={12}>
            <Card className="ps-card-display main">
              <CardBody>
                <Nav tabs className="ps-tab">
                  {this.state.tabList.map((item, index) => {
                    return (
                      <NavItem key={item.name}>
                        <NavLink
                          className={classnames({
                            active: activeTab === (index + 1).toString(),
                          })}
                          onClick={() => {
                            this.toggleTab((index + 1).toString())
                          }}>
                          {item.name}
                        </NavLink>
                      </NavItem>
                    )
                  })}
                </Nav>

                {this.state.store_id && (
                  <TabContent activeTab={activeTab}>
                    <TabPane tabId="1" className="py-3">
                      <PosStoreProductTable isGlobal={false} data={this.state} {...this.props} />
                    </TabPane>
                    {this.state.role == 'Admin' && (
                      <>
                        <TabPane tabId="2" className="py-3">
                          <PosUserTable isGlobal={false} data={this.state} />
                        </TabPane>
                        <TabPane tabId="3" className="py-3">
                          <PosPaymentTypeTable isGlobal={false} data={this.state} />
                        </TabPane>
                        <TabPane tabId="4" className="py-3">
                          <PosTaxTable isGlobal={false} data={this.state} />
                        </TabPane>
                      </>
                    )}
                    <TabPane tabId={this.state.role == 'Admin' ? '5' : '2'} className="py-3">
                      <PosScheduleTable isGlobal={false} data={this.state} {...this.props} />
                    </TabPane>
                    {this.state.role == 'Admin' && (
                      <>
                        <TabPane tabId="6" className="py-3">
                          <PosSyncStockTable isGlobal={false} data={this.state} />
                        </TabPane>
                        <TabPane tabId="7" className="py-3">
                          <PosShippingTable isGlobal={false} data={this.state} />
                        </TabPane>
                        <TabPane tabId="8" className="py-3">
                          <PosDeliveryCollectionTable isGlobal={false} data={this.state} />
                        </TabPane>
                        <TabPane tabId="9" className="py-3">
                          <PosPromoTable isGlobal={false} data={this.state} />
                        </TabPane>
                      </>
                    )}
                    {(this.state.role == 'Admin' || this.state.role == 'Supervisor') && (
                      <>
                        <TabPane tabId="10" className="py-3">
                          <PosEmailAlertTable isGlobal={false} data={this.state} {...this.props} />
                        </TabPane>
                        <TabPane tabId="11" className="py-3">
                          <PosSMSAlertTable isGlobal={false} data={this.state} {...this.props} />
                        </TabPane>
                      </>
                    )}
                  </TabContent>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Modal isOpen={this.state.modal} toggle={this.toggle()} className={this.props.className} centered>
          <PosStoreForm history={this.props.history} onToggleModal={this.toggle} closeModal={this.closeModal} match={this.props.match} data={this.state} />
        </Modal>

        <Modal isOpen={this.state.configureModal} className="modal-xl" centered>
          <PosStoreConfigureModal history={this.props.history} onToggleModal={this.toggleConfigure} closeModal={this.closeModal} match={this.props.match} data={this.state} getStoreDetail={this.getStoreDetail} />
        </Modal>

        <Modal isOpen={this.state.ecartModal} toggle={this.toggleEcart()} className={this.props.className} centered style={{ fontSize: '0.85rem' }}>
          <ModalHeader toggle={this.toggleEcart()}>Ecart Configuration</ModalHeader>
          <Form className="AuthForm" onSubmit={this.EcartConfigure}>
            <ModalBody>
              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Label>Order Mode</Label>
                    <Input type="select" name="edit_order_mode" value={this.state.edit_order_mode} onChange={this.changeHandler} required>
                      <option></option>
                      <option value="Order">Order</option>
                      <option value="Scheduled">Scheduled</option>
                    </Input>
                  </FormGroup>
                  <FormGroup>
                    <Label>Open Date</Label>
                    <Input type="date" name="edit_opendate" value={this.state.edit_opendate} onChange={this.changeHandler} required />
                  </FormGroup>
                  <FormGroup>
                    <Label>Close Date</Label>
                    <Input type="date" name="edit_closedate" value={this.state.edit_closedate} onChange={this.changeHandler} required />
                  </FormGroup>
                  <FormGroup>
                    <Label>Open Time</Label>
                    <Input type="time" name="edit_opentime" value={this.state.edit_opentime} onChange={this.changeHandler} required />
                  </FormGroup>
                  <FormGroup>
                    <Label>Close Time</Label>
                    <Input type="time" name="edit_closetime" value={this.state.edit_closetime} onChange={this.changeHandler} required />
                  </FormGroup>
                  <FormGroup check>
                    <Label>
                      <Input type="checkbox" name="edit_password_ecart" checked={this.state.edit_password_ecart} onChange={this.checkHandler} />
                      Enable Password
                    </Label>
                  </FormGroup>
                  <FormGroup>
                    <Label>Password</Label>
                    <Input type="text" name="edit_password" value={this.state.edit_password} maxLength="20" required={this.state.edit_password_ecart} onChange={this.changeHandler} />
                  </FormGroup>
                  <FormGroup check>
                    <Label>
                      <Input type="checkbox" name="edit_show_timer" checked={this.state.edit_show_timer} onChange={this.checkHandler} />
                      Show Timer Countdown
                    </Label>
                  </FormGroup>
                  <FormGroup>
                    <Label>Timer Title</Label>
                    <Input type="text" name="edit_timer_title" value={this.state.edit_timer_title} onChange={this.changeHandler} />
                  </FormGroup>
                  <FormGroup>
                    <Label>Postal</Label>
                    <Input name="edit_postal_location" value={this.state.edit_postal_location} onChange={this.postalHandler} maxLength={6} />
                  </FormGroup>
                  <FormGroup>
                    <Label>Lat & Long</Label>
                    <Input name="edit_postal_latlong" value={this.state.edit_postal_latlong} onChange={this.changeHandler} />
                  </FormGroup>
                  <FormGroup check>
                    <Label>
                      <Input type="checkbox" name="edit_show_watsapp" checked={this.state.edit_show_watsapp} onChange={this.checkHandler} />
                      Show Whatsapp Contact Button
                    </Label>
                  </FormGroup>
                  <FormGroup>
                    <Label>Whatsapp Contact (Include country code without +) Example 6591111111</Label>
                    <Input
                      name="edit_watsapp"
                      value={this.state.edit_watsapp}
                      required={this.state.edit_show_watsapp}
                      //maxLength="8"
                      onChange={this.mobileHandler}
                    />
                  </FormGroup>
                  <FormGroup check>
                    <Label>
                      <Input type="checkbox" name="edit_show_price_filter" checked={this.state.edit_show_price_filter} onChange={this.checkHandler} />
                      Show Price Filter
                    </Label>
                  </FormGroup>
                </Col>
                {this.state.isLoading && (
                  <div
                    style={{
                      position: 'fixed',
                      left: '50%',
                      top: '50%',
                      marginLeft: '-10px',
                    }}>
                    <Spinner animation="border" variant="primary" />
                  </div>
                )}
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button className="theme-button theme-button-primary" type="submit">
                Save
              </Button>
            </ModalFooter>
          </Form>
        </Modal>

        <Modal isOpen={this.state.siloModal} toggle={this.toggleSilo()} className={this.props.className} centered style={{ fontSize: '0.85rem' }}>
          <ModalHeader toggle={this.toggleSilo()}>Silo Configuration</ModalHeader>
          <Form className="AuthForm" onSubmit={this.SiloConfigure}>
            <ModalBody>
              <Row>
                <Col md={12}>
                  <FormGroup check>
                    <Label>
                      <Input type="checkbox" name="edit_silo_hide_price" checked={this.state.edit_silo_hide_price} onChange={this.checkHandler} />
                      Hide Price
                    </Label>
                  </FormGroup>
                  <FormGroup check>
                    <Label>
                      <Input type="checkbox" name="edit_silo_filter_tag" checked={this.state.edit_silo_filter_tag} onChange={this.checkHandler} />
                      Filter Tag by Group
                    </Label>
                  </FormGroup>
                  <FormGroup check>
                    <Label>
                      <Input type="checkbox" name="edit_self_collection_disable_billing" checked={this.state.edit_self_collection_disable_billing} onChange={this.checkHandler} />
                      Disable Billing for Self Collection
                    </Label>
                  </FormGroup>
                </Col>
                {this.state.isLoading && (
                  <div
                    style={{
                      position: 'fixed',
                      left: '50%',
                      top: '50%',
                      marginLeft: '-10px',
                    }}>
                    <Spinner animation="border" variant="primary" />
                  </div>
                )}
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button className="theme-button theme-button-primary" type="submit">
                Save
              </Button>
            </ModalFooter>
          </Form>
        </Modal>

        <Modal isOpen={this.state.confirmModal} toggle={this.toggleConfirmModal()} className={this.props.className} centered style={{ fontSize: '0.85rem' }}>
          <ModalHeader toggle={this.toggleConfirmModal()}>Delete Store</ModalHeader>
          <ModalBody>
            <Row>
              <Col md={12}>
                <p>Are you sure you want to delete {this.state.store_name} ?</p>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button className="theme-button theme-button-secondary" onClick={this.toggleConfirmModal()}>
              No
            </Button>
            <Button className="theme-button theme-button-primary" onClick={() => this.delete()}>
              Yes
            </Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.uploadModal} toggle={this.toggleUpload()} className={this.props.className} centered style={{ fontSize: '0.85rem' }}>
          <ModalHeader toggle={this.toggleUpload()}>Upload Banner</ModalHeader>
          <Form onSubmit={this.Banner}>
            <ModalBody>
              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Label>Banner (Recommended size 1920*1080, Limit to 2MB)</Label>
                    <Input type="file" name="edit_banner" onChange={this.handleAttachmentChange} required />
                  </FormGroup>
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button className="theme-button theme-button-primary" type="submit">
                Save
              </Button>
            </ModalFooter>
          </Form>
        </Modal>

        <Modal isOpen={this.state.mobilebannerModal} toggle={this.toggleMobileBanner()} className={this.props.className} centered style={{ fontSize: '0.85rem' }}>
          <ModalHeader toggle={this.toggleMobileBanner()}>Upload Banner</ModalHeader>
          <Form onSubmit={this.MobileBanner}>
            <ModalBody>
              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Label>Mobile Banner (Recommended size 576*300, Limit to 2MB)</Label>
                    <Input type="file" name="edit_mobile_banner" onChange={this.handleAttachmentChange} required />
                  </FormGroup>
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button className="theme-button theme-button-primary" type="submit">
                Save
              </Button>
            </ModalFooter>
          </Form>
        </Modal>

        <Modal isOpen={this.state.runninginvoiceModal} toggle={this.toggleRunningInvoice()} className={this.props.className} centered style={{fontSize:'0.85rem'}}>
            <ModalHeader toggle={this.toggleRunningInvoice()}>Last Invoice</ModalHeader>
            <Form onSubmit={this.last_invoice}>
              <ModalBody>
                <Row>
                  <Col md={12}>
                    <FormGroup>
                      <Label>Last Invoice</Label>
                      <Input name="edit_running_invoice" value={this.state.edit_running_invoice} onChange={this.lastInvoiceHandler}/>
                    </FormGroup>
                  </Col>
                </Row>
              </ModalBody>
              <ModalFooter>
                <Button className="theme-button theme-button-primary" type="submit">Save</Button>
              </ModalFooter>
            </Form>
        </Modal>
      </Page>
    )
  }
}

export default PosStoreDetailPage
